// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1gjgG","controls":"styles_controls__2vL9X","charLimit":"styles_charLimit__3Gpni","input":"styles_input__15eaU","send":"styles_send__2kUjO"};